import type { SelectOptionProp } from '@ui/SelectField/types';

export type PolicyProductNameOption = {
  value: string;
  label: string;
};

export function mapPolicyProductNameOptions(
  payload: unknown
): SelectOptionProp[] {
  const rows = Array.isArray(payload)
    ? payload
    : payload &&
        typeof payload === 'object' &&
        Array.isArray((payload as { data?: unknown }).data)
      ? (payload as { data: unknown[] }).data
      : [];

  return rows.flatMap((row) => {
    if (!row || typeof row !== 'object') {
      return [];
    }
    const value = String(
      (row as PolicyProductNameOption).value ??
        (row as { label?: string }).label ??
        ''
    ).trim();
    if (!value) {
      return [];
    }
    return [{ value, label: value }];
  });
}

export function filterPolicyProductNameOptions(
  options: SelectOptionProp[],
  searchTerm?: string
): SelectOptionProp[] {
  const term = searchTerm?.trim().toLowerCase();
  if (!term) {
    return options;
  }

  return options.filter(
    (option) =>
      option.label.toLowerCase().includes(term) ||
      `${option.value}`.toLowerCase().includes(term)
  );
}
